import styled from '@emotion/styled';
import React from 'react';

const Divider = styled.div({
  borderBottom: '1px solid #9F9F9F',
  paddingTop: '1rem',
  width: '43rem',
});

export default Divider;
